export default {
  AVP: 'AVP',
  VIRTUAL: 'VIRTUAL',
};
